import React from 'react';
import EmbaettiFilter from 'pages/tolfraedi/components/filters/EmbaettiFilter';
import SveitarfelagFilter from 'pages/tolfraedi/components/filters/SveitarfelagFilter';
import KjordaemiFilter from 'pages/tolfraedi/components/filters/KjordaemiFilter';
import { Grid } from "@material-ui/core";


export default function Filters(props) {
  const { setFilters, setEmbaettiFromFilter, setSveitarfelagFromFilter } = props;

  return (
    <React.Fragment>
      <Grid item>
        <EmbaettiFilter
          setFilters={setFilters}
          setEmbaettiFromFilter={setEmbaettiFromFilter}
        />
      </Grid>
      <Grid item>
        <KjordaemiFilter setFilters={setFilters} />
      </Grid>
      <Grid item>
        <SveitarfelagFilter
          setFilters={setFilters}
          setSveitarfelagFromFilter={setSveitarfelagFromFilter}
        />
      </Grid>
    </React.Fragment>
  );
}